import { isNull, isString } from 'lodash';
import React, { useRef } from 'react';
import { formatColor } from '@meitu/saas-colors';
import { IBrushLayerProps } from '@meitu/saas-editor-core/es/version-types';
import LabelAction from '@meitu/saas-editor-ui/es/components/label-action';
import { useGlobalWidget } from '@meitu/saas-editor-ui/es/hooks/use-global-widget';
import { useListenActivePickLayerProps } from '@meitu/saas-editor-ui/es/hooks/use-listen-layer-props';
import { ColorGroup } from '@meitu/xdesign-widgets';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';

export const StrokeFeature: React.FC<{
    id: string;
    onAfterChange?: Function;
}> = React.memo(({ id, onAfterChange }) => {
    const { $t } = useLocaleStore();
    const originVal = useRef<string | null>(null);
    const originId = useRef<string>('');

    const stroke = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;
        const { stroke } = layer.data as IBrushLayerProps;
        return isString(stroke.color) ? stroke.color : (formatColor(stroke.color) as string);
    });

    const colorGlobalWidgetRef = useGlobalWidget(editor, false);

    if (isNull(stroke)) return null;

    return (
        <div className="c-brush-panel__item">
            <LabelAction title={$t((v) => v.panel.brushPanel.color)} align={true}>
                <ColorGroup
                    onOpenChange={(e) => {
                        colorGlobalWidgetRef.current = e;
                    }}
                    popupTriggerSize={{
                        width: 78,
                        height: 32,
                    }}
                    color={stroke}
                    setColor={(val) => {
                        if (originVal.current === null) {
                            originVal.current = stroke;
                            originId.current = id;
                        }
                        editor.brushLayer.setColor(id, val, true, 0);
                    }}
                    setColorAfter={(val, __, { isBrandColor }) => {
                        if (isBrandColor) {
                            window._stat_track?.('hb_layers_func_use', {
                                func_id: '8_107',
                            });
                        }
                        if (originVal.current) {
                            editor.brushLayer.setColor(originId.current, val, true, 0, originVal.current);
                        }
                        originVal.current = null;
                        onAfterChange?.(19);
                    }}
                    isGradient={true}
                    popupOverlayClassName="c-brush-panel__color-picker"
                    onToggleBizTab={(bizTab) => {
                        if (bizTab === 'team') {
                            window._stat_track?.('hb_layers_func_click', {
                                func_id: '8_107',
                            });
                        }
                    }}
                />
            </LabelAction>
        </div>
    );
});
